import { useQuery } from 'react-query';

import { getQRCode as queryFn } from 'api/endPoints/getQRCode';

export const useQueryGetQRCode = (params) => {
    return useQuery({
        queryKey: ['getQRCode', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.email),
    });
};
